<template>
  <div id="detailPage" class="detailPage">
    <!-- <button @click="daochu('detailPage', orderDetailData.orderNumber)">导出</button> -->
    <p class="title">基本信息</p>
    <ul class="ulBox clearFloat">
      <li>
        <div class="left">包装单号：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.orderNumber">{{
            orderDetailData.orderNumber
          }}</span>
          <span v-else>-</span>
          <i v-if="orderDetailData.status && orderDetailData.status.code=='READY'"
            class="el-icon-edit allowSkip" 
            @click="editOrderNumber(orderDetailData.orderNumber)"
          ></i>
        </div>
      </li>
      <li>
        <div class="left">客户：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.customer">{{
            orderDetailData.customer.name
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">裸机数量：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.quantity"
            >{{ orderDetailData.quantity }}PCS            
            <i v-if="orderDetailData.status && orderDetailData.status.code=='READY'"
              class="el-icon-edit allowSkip"
              @click="editQuantityBtn(orderDetailData.quantity)"
            ></i>
          </span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">SAP单号：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.sapOrderNumber">{{
            orderDetailData.sapOrderNumber
          }}</span>
          <span v-else>-</span>
          <i
            class="el-icon-edit allowSkip"
            @click="editSapOrderNumber(orderDetailData.sapOrderNumber)"
          ></i>
        </div>
      </li>
      <li>
        <div class="left">成品编码：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.itemCode">
            {{ orderDetailData.itemCode }}
            </span>
          <span v-else>- </span>
          <i v-if="orderDetailData.status && orderDetailData.status.code=='READY'"
            class="el-icon-edit allowSkip" 
            @click="editItemCode(orderDetailData.itemCode)"
          ></i>
        </div>
      </li>
      <li>
        <div class="left">客户PO/料号：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.customerPo">
            {{ orderDetailData.customerPo }}
            </span>
          <span v-else>- </span>
          <i v-if="orderDetailData.status && orderDetailData.status.code=='READY'"
            class="el-icon-edit allowSkip" 
            @click="editCustomerPo(orderDetailData.customerPo)"
          ></i>
        </div>
      </li>
      <li>
        <div class="left">国家码：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.countryCode">
            {{ orderDetailData.countryCode }}
            </span>
          <span v-else>- </span>
          <i v-if="orderDetailData.status && orderDetailData.status.code=='READY'"
            class="el-icon-edit allowSkip" 
            @click="editCountryCode(orderDetailData.countryCode)"
          ></i>
        </div>
      </li>
      <li>
        <div class="left">包装说明：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.packageFid == '****'">
            已上传
          </span>
          <span class="value" v-else-if="orderDetailData.packageFid > 0">
            {{orderDetailData.packageFidUploadDateTime}}(fid=<span
              class="allowSkip"
              @click="downloadFile(orderDetailData.packageFid)"
              >{{orderDetailData.packageFid}}</span>)
          </span>
          <span v-else>待上传</span>          
          <span style="margin-left:15px" v-if="orderDetailData.createUser && orderDetailData.createUser.id == this.$store.state.userInfo.id && orderDetailData.status && orderDetailData.status.code=='READY'"
            class="allowSkip"
            @click="uploadPackageFidBtn(orderDetailData.packageFid)"
            >
            <i style="margin-left:-15px" :title="orderDetailData.status.code=='READY' ? '上传' : '重新上传'"
              class="el-icon-upload2" 
            ></i>
          </span>
          <input
            ref="uploadPackageFidInput"
            type="file"
            @change="uploadPackageFidChange()"
            style="display: none"
          />
        </div>
      </li>
      <li>
        <div class="left">开始包装时间：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.startDate">
            {{ orderDetailData.startDate }}
            <i v-if="orderDetailData.status && orderDetailData.status.code=='READY'"
              class="el-icon-edit allowSkip" 
              @click="editStartDate(orderDetailData.startDate)"
            ></i>
          </span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">结单时间：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.closedDate">{{
            orderDetailData.closedDate
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">状态：</div>
        <div class="right">
          <span
            class="value"
            v-if="orderDetailData.status"
            :class="{ danger: orderDetailData.status.code == 'LOCKED' }"
            >{{ orderDetailData.status.title }}</span
          >
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">所有者：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.createUser"
            >{{ orderDetailData.createUser.name }}({{ orderDetailData.createUser.employeeNum }})</span
          >
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">备注：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.notes">{{
            orderDetailData.notes
          }}</span>
          <span v-else>-</span>
          <i v-if="orderDetailData.status && orderDetailData.status.code=='READY'"
            class="el-icon-edit allowSkip" 
            @click="editNotes(orderDetailData.notes)"
          ></i>
        </div>
      </li>
      <li class="blockLi">
        <div class="left">组装工单：</div>
        <div class="right">
          <el-table
            class="myProductionOrder"
            stripe
            :data="orderDetailData.productionOrders"
            border
            style="width: 100%"
            size="mini"
          >
            <el-table-column
              prop="orderNumber"
              label="组装工单"
              min-width="120"
              align="left"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span v-if="scope.row.orderNumber">
                  <el-tooltip
                    effect="dark"
                    :content="scope.row.primary?'主工单':'设置主工单'"
                    placement="top"
                    :open-delay="300"
                  >
                    <i
                      v-if="scope.row.id > 0 && scope.row.primary"
                      class="iconfont icon-key-fill"
                    ></i>
                    <i
                      v-else-if="orderDetailData.status && (orderDetailData.status.code=='READY' || orderDetailData.status.code=='PRODUCTION') && scope.row.id > 0 && !scope.row.primary"
                      @click="setPrimary($event, scope.row)"
                      class="iconfont icon-yuechi"
                      style="cursor: pointer"
                    ></i>
                  </el-tooltip>
                  {{ scope.row.orderNumber }}</span
                >
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="product"
              label="型号"
              min-width="80"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span v-if="scope.row.product">{{
                  scope.row.product.code
                }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="quantity"
              label="数量"
              width="80"
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.quantity">{{ scope.row.quantity }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="itemCode"
              label="成品编码"
              align="center"
              min-width="100"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span v-if="scope.row.itemCode">{{ scope.row.itemCode }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="countAll"
              label="投入数量"
              width="80"
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.done.countAll && scope.row.done.countAll>0">{{ scope.row.done.countAll }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="done"
              label="内箱完成"
              width="80"
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.done.inner && scope.row.done.inner > 0">{{
                  scope.row.done.inner
                }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="done"
              label="外箱完成"
              width="80"
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.done.outer && scope.row.done.outer > 0">{{
                  scope.row.done.outer
                }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="done"
              label="栈板完成"
              width="80"
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.done.pallet && scope.row.done.pallet > 0">{{
                  scope.row.done.pallet
                }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column
              class-name="operation"
              label="操作"
              align="center"
              width="70px"
            >
              <template slot-scope="scope">
                <el-tooltip
                    v-if="orderDetailData.status && orderDetailData.status.code=='READY' &&
                      scope.$index != orderDetailData.productionOrders.length - 1 && scope.row.done.countAll==0
                    "
                  effect="dark"
                  content="删除"
                  placement="top"
                  :open-delay="300"
                >
                  <i
                    @click="deleteOrder($event, scope.row)"
                    class="el-icon-delete"
                  ></i>
                </el-tooltip>
                <span v-if="orderDetailData.status && (orderDetailData.status.code=='READY' || orderDetailData.status.code=='PRODUCTION') &&
                      scope.$index != orderDetailData.productionOrders.length - 1 && scope.row.done.countAll>0">-</span>
                <el-tooltip
                    v-if="orderDetailData.status && orderDetailData.status.code=='READY' &&
                      scope.$index == orderDetailData.productionOrders.length - 1"
                  effect="dark"
                  content="添加"
                  placement="top"
                  :open-delay="300"
                >
                  <i
                    @click="addOrder($event, scope.row)"
                    class="el-icon-plus"
                  ></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </li>
    </ul>
    <el-divider></el-divider>
    <div class="titleBox">
      <p class="title">彩盒</p>
      <el-button v-if="orderDetailData.status && orderDetailData.status.code=='READY'" type="primary" size="mini" @click="updateCartonSpec('彩盒', 'weight', weightData, weightData2)"
        >修改</el-button
      >
    </div>
    <ul class="ulBox clearFloat">
      <li>
        <div class="left">最小重量：</div>
        <div class="right">
          <span class="value" v-if="weightData.min">
            {{ weightData.min }}g
          </span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">最大重量：</div>
        <div class="right">
          <span class="value" v-if="weightData.max">
            {{ weightData.max }}g
          </span>
          <span v-else>-</span>
        </div>
      </li>
      <li v-if="weightData2 && weightData2.min>0 && weightData2.max>0">
        <div class="left">最小重量：</div>
        <div class="right">
          <span class="value" v-if="weightData2.min">
            {{ weightData2.min }}g
          </span>
          <span v-else>-</span>
        </div>
      </li>
      <li v-if="weightData2 && weightData2.min>0 && weightData2.max>0">
        <div class="left">最大重量：</div>
        <div class="right">
          <span class="value" v-if="weightData2.max">
            {{ weightData2.max }}g
          </span>
          <span v-else>-</span>
        </div>
      </li>   
    </ul>
    <div class="titleBox">
      <p class="title">内箱</p>
      <el-button v-if="orderDetailData.status && orderDetailData.status.code=='READY'" type="primary" size="mini" @click="updateCartonSpec('内箱', 'inner', innerDate)"
        >修改</el-button
      >
    </div>
    <ul class="ulBox clearFloat">
      <li>
        <div class="left">包装规格：</div>
        <div class="right">
          <span class="value" v-if="innerDate.pack"
            >{{ innerDate.pack }} PCS/箱 * {{ innerDate.ctnCount }}</span
          >
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">混装比例：</div>
        <div class="right">
          <span class="value" v-if="innerDate.scale">{{
            innerDate.scale.title
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">箱号模板：</div>
        <div class="right">
          <span class="value" v-if="innerDate.snTemplate">{{
            innerDate.snTemplate
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">流水长度：</div>
        <div class="right">
          <span class="value" v-if="innerDate.numLen">{{
            innerDate.numLen
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">起始箱号：</div>
        <div class="right">
          <span class="value" v-if="innerDate.startIndex">{{
            innerDate.startIndex
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">最小重量：</div>
        <div class="right">
          <span class="value" v-if="innerDate.minWeight">
            {{ innerDate.minWeight }}kg
          </span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">最大重量：</div>
        <div class="right">
          <span class="value" v-if="innerDate.maxWeight">
            {{ innerDate.maxWeight }}kg
          </span>
          <span v-else>-</span>
        </div>
      </li>
    </ul>
    <div class="titleBox">
      <p class="title">外箱</p>
      <el-button v-if="orderDetailData.status && orderDetailData.status.code=='READY'" type="primary" size="mini" @click="updateCartonSpec('外箱', 'outer', outerDate)"
        >修改</el-button
      >
    </div>
    <ul class="ulBox clearFloat">
      <li>
        <div class="left">包装规格：</div>
        <div class="right">
          <span class="value" v-if="outerDate.pack"
            >{{ outerDate.pack }} PCS/箱 * {{ outerDate.ctnCount }}</span
          >
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">混装比例：</div>
        <div class="right">
          <span class="value" v-if="outerDate.scale">{{
            outerDate.scale.title
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">箱号模板：</div>
        <div class="right">
          <span class="value" v-if="outerDate.snTemplate">{{
            outerDate.snTemplate
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">流水长度：</div>
        <div class="right">
          <span class="value" v-if="outerDate.numLen">{{
            outerDate.numLen
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">起始箱号：</div>
        <div class="right">
          <span class="value" v-if="outerDate.startIndex">{{
            outerDate.startIndex
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">最小重量：</div>
        <div class="right">
          <span class="value" v-if="outerDate.minWeight">
            {{ outerDate.minWeight }}kg
          </span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">最大重量：</div>
        <div class="right">
          <span class="value" v-if="outerDate.maxWeight">
            {{ outerDate.maxWeight }}kg
          </span>
          <span v-else>-</span>
        </div>
      </li>
    </ul>
    <div class="titleBox">
      <p class="title" style="width:146px">栈板/送检批次</p>
      <el-button v-if="orderDetailData.status && orderDetailData.status.code=='READY'" type="primary" size="mini" @click="updateCartonSpec('栈板', 'pallet', palletDate)"
        >修改</el-button
      >
    </div>
    <ul class="ulBox clearFloat">
      <li>
        <div class="left">OQC送检批次：</div>
        <div class="right">
          <span class="value" v-if="palletDate.pack"
            >{{ palletDate.pack }} PCS/栈板 * {{ palletDate.ctnCount }}</span
          >
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">混装比例：</div>
        <div class="right">
          <span class="value" v-if="palletDate.scale">{{
            palletDate.scale.title
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">栈板号模板：</div>
        <div class="right">
          <span class="value" v-if="palletDate.snTemplate">{{
            palletDate.snTemplate
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">流水长度：</div>
        <div class="right">
          <span class="value" v-if="palletDate.numLen">{{
            palletDate.numLen
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">起始栈板号：</div>
        <div class="right">
          <span class="value" v-if="palletDate.startIndex">{{
            palletDate.startIndex
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">最小重量：</div>
        <div class="right">
          <span class="value" v-if="palletDate.minWeight">
            {{ palletDate.minWeight }}kg
          </span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">最大重量：</div>
        <div class="right">
          <span class="value" v-if="palletDate.maxWeight">
            {{ palletDate.maxWeight }}kg
          </span>
          <span v-else>-</span>
        </div>
      </li>
    </ul>

    <div class="titleBox">
      <p class="title">QC</p>
      <el-button type="primary" size="mini" @click="updateQC(orderDetailData)"
        >修改</el-button
      >
    </div>
    <ul class="ulBox clearFloat">
      <li style="width:33.3%">
        <div class="left">CRI AQL：</div>
        <div class="right">
          <span class="value"
            >{{ orderDetailData.criAql }}</span
          >
        </div>
      </li>
      
      <li style="width:33.3%">
        <div class="left">MAJ AQL：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.majAql"
            >{{ orderDetailData.majAql }}</span
          >
          <span v-else>-</span>
        </div>
      </li>

      <li style="width:33.3%">
        <div class="left">MIN AQL：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.minAql"
            >{{ orderDetailData.minAql }}</span
          >
          <span v-else>-</span>
        </div>
      </li>
    </ul>
    
    <myDialog
      ref="myDialog"
      :title="dialogTitle"
      @submitData="submitData"
      @dialogClose="dialogClose"
      width="450px"
    >
      <template slot="content">
        <el-form
          ref="dialogForm"
          :model="dialogForm"
          :rules="dialogRules"
          :label-width="labelWidth"
        >
          <template v-if="dialogTitle == '修改工单数量'">
            <el-form-item label="包装数量：" size="small" prop="quantity">
              <el-input-number
                v-model="dialogForm.quantity"
                :min="0"
                :precision="0"
                placeholder="包装工单数量"
                :controls="false"
              ></el-input-number>
            </el-form-item>
          </template>
          <template v-if="dialogTitle == '添加组装工单'">
            <el-form-item label="组装工单" size="small" prop="productionOrderId" key="order">
              <el-select v-model="dialogForm.productionOrderId" filterable remote placeholder="工单号前五个字符"
                @keyup.enter.native="remoteMethod" :loading="processOrdeer.loading" clearable
                :popper-class="processOrdeer.proOrderFilterText.length >= 5 ? '' : 'proOrderPullHidden'"
              >
                <el-option
                  v-for="item in pullDownData.productOrderList"
                  :key="item.id"
                  :label="item.orderNumber"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </template>
          <template v-else-if="dialogTitle == '修改开始包装时间'">
            <el-form-item label="开始时间：" size="small" prop="dateTime" key="dateTime">
              <el-date-picker
                v-model="dialogForm.dateTime"
                type="datetime"
                placeholder="输入开始包装时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                clearable
                :picker-options="$store.state.pickerOptions"
              ></el-date-picker>
            </el-form-item>
          </template>
          <template v-else-if="dialogTitle == '修改国家码'">
            <el-form-item label="国家码：" size="small" prop="countryCode">
              <el-input
                v-model="dialogForm.countryCode"
                placeholder="输入国家码"
                clearable
              ></el-input>
            </el-form-item>
          </template>
          <template v-else-if="dialogTitle == '修改备注'">
            <el-form-item label="备注：" size="small" prop="notes">
              <el-input
                v-model="dialogForm.notes"
                placeholder="输入备注"
                clearable
              ></el-input>
            </el-form-item>
          </template>
          <template v-else-if="dialogTitle == '修改客户PO/料号'">
            <el-form-item label="客户PO/料号：" size="small" prop="customerPo">
              <el-input
                v-model="dialogForm.customerPo"
                placeholder="输入客户PO/料号"
                clearable
              ></el-input>
            </el-form-item>
          </template>
          <template v-else-if="dialogTitle == '修改包装单号'">
            <el-form-item label="包装单号：" size="small" prop="orderNumber">
              <el-input
                v-model="dialogForm.orderNumber"
                placeholder="输入新包装单号"
                clearable
              ></el-input>
            </el-form-item>
          </template>
          <template v-else-if="dialogTitle == '修改SAP单号'">
            <el-form-item label="SAP单号：" size="small" prop="sapOrderNumber">
              <el-input
                v-model="dialogForm.sapOrderNumber"
                placeholder="输入SAP单号"
                clearable
              ></el-input>
            </el-form-item>
          </template>
          <template v-else-if="dialogTitle == '修改成品编码'">
            <el-form-item label="成品编码：" size="small" prop="itemCode">
              <el-input
                v-model="dialogForm.itemCode"
                placeholder="输入成品编码"
                clearable
              ></el-input>
            </el-form-item>
          </template>
          <div v-else-if="dialogTitle == `修改彩盒规格`" key="weight">
            <el-form-item label="最小重量：" size="small" prop="weight.min">
              <el-input-number v-model="dialogForm.weight.min" :min="0" :precision="1" placeholder="最小重量（单位：g）"></el-input-number>
            </el-form-item>
            <el-form-item label="最大重量：" size="small" prop="weight.max">
              <el-input-number v-model="dialogForm.weight.max" :min="0" :precision="1" placeholder="最大重量（单位：g）"></el-input-number>
            </el-form-item>
            <el-divider></el-divider>            
            <div class="tips tipsBox">
              <span class="text">工单含有不同单品，如：IPC+NVR，请设置以下称重值：</span>
            </div>
            <el-form-item label="最小重量：" size="small" prop="weight2.min">
              <el-input-number v-model="dialogForm.weight2.min" :min="0" :precision="1" placeholder="最小重量（单位：g）"></el-input-number>
            </el-form-item>
            <el-form-item label="最大重量：" size="small" prop="weight2.max">
              <el-input-number v-model="dialogForm.weight2.max" :min="0" :precision="1" placeholder="最大重量（单位：g）"></el-input-number>
            </el-form-item>
          </div>
          <div v-else-if="dialogTitle == `修改内箱规格`" key="inner">
            <el-form-item
              label="包装规格："
              size="small"
              prop="inner.pack"
            >
              <el-input-number
                v-model="dialogForm.inner.pack"
                :min="0"
                :precision="0"
                placeholder="套装填，不是套装不要填！！！"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="混装比例："
              size="small"
              prop="innerScale"
            >
              <el-select
                v-model="dialogForm.inner.scale"
                placeholder="选择混装比例"
                filterable
              >
                <el-option
                  v-for="(item, index) in $parent.pullDownData.cartonScaleList"
                  :key="index"
                  :label="item.title"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="箱号模板：" size="small">
              <el-input style="width:92%"
                v-model.trim="dialogForm.inner.snTemplate"
                placeholder="如:ANC${yyyy}${MM}${dd}%05d"
                clearable
              ></el-input>
              <el-popover style="margin-left: 3px;"
              placement="bottom" 
              title="提示："
              trigger="hover"
              >
              <div style="margin-bottom:5px;">${yyyy}表示年，如2022年表示为2022。</div>
              <div style="margin-bottom:5px;">${yy}表示年，如2022年表示为22。</div>
              <div style="margin-bottom:5px;">${MM}表示月，如小于10月份，则加零补齐，1月表示为01。</div>
              <div style="margin-bottom:5px;">${M}表示月，月份不补齐，如1月份表示为1。</div>
              <div style="margin-bottom:5px;">${dd}表示日，如小于10号，则加零补齐，1号表示为01。</div>
              <div style="margin-bottom:5px;">${d}表示日，日期不补齐，如1号表示为1。</div>
              <div style="margin-bottom:5px;">${WW}表示一年中的第几周。如小于10，则加零补齐，如1号表示为01。</div>
              <div style="margin-bottom:5px;">${W}表示一年中的第几周。不补齐，如1号表示为1。</div>
              <div style="margin-bottom:5px;">%05d表示流水号长度：5，流水号前补0，为00001，递增。如要更改流水号长度为4则把05改为04即可。</div>
                <i class="el-icon-question" slot="reference"></i>
              </el-popover>
            </el-form-item>
            <el-form-item label="流水号长度：" size="small">
              <el-input-number
                v-model="dialogForm.inner.numLen"
                :min="1"
                placeholder="如：5，流水号前补0，为00001，递增。"
                clearable
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="起始箱号："
              size="small"
              prop="innerStartIndex"
            >
              <el-input-number
                v-model="dialogForm.inner.startIndex"
                :min="1"
                :precision="0"
                placeholder="默认从1开始"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="最小重量："
              size="small"
              prop="inner.minWeight"
            >
              <el-input-number
                v-model="dialogForm.inner.minWeight"
                :min="0"
                :precision="1"
                placeholder="最小重量（单位：g）"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="最大重量："
              size="small"
              prop="inner.maxWeight"
            >
              <el-input-number
                v-model="dialogForm.inner.maxWeight"
                :min="0"
                :precision="1"
                placeholder="最大重量（单位：g）"
              ></el-input-number>
            </el-form-item>
          </div>
          <div v-else-if="dialogTitle == `修改外箱规格`" key="outer">
            <el-form-item
              label="包装规格："
              size="small"
              prop="outer.pack"
            >
              <el-input-number
                v-model="dialogForm.outer.pack"
                :min="1"
                :precision="0"
                placeholder="每个包装单位的裸机数量"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="混装比例："
              size="small"
              prop="outerScale"
            >
              <el-select
                v-model="dialogForm.outer.scale"
                placeholder="选择混装比例"
                filterable
              >
                <el-option
                  v-for="(item, index) in $parent.pullDownData.cartonScaleList"
                  :key="index"
                  :label="item.title"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="箱号模板：" size="small">
              <el-input style="width:92%"
                v-model.trim="dialogForm.outer.snTemplate"
                placeholder="如：AN${yyyy}${MM}${dd}%05d"
                clearable
              ></el-input>
              <el-popover style="margin-left: 3px;"
              placement="bottom" 
              title="提示："
              trigger="hover"
              >
              <div style="margin-bottom:5px;">${yyyy}表示年，如2022年表示为2022。</div>
              <div style="margin-bottom:5px;">${yy}表示年，如2022年表示为22。</div>
              <div style="margin-bottom:5px;">${MM}表示月，如小于10月份，则加零补齐，1月表示为01。</div>
              <div style="margin-bottom:5px;">${M}表示月，月份不补齐，如1月份表示为1。</div>
              <div style="margin-bottom:5px;">${dd}表示日，如小于10号，则加零补齐，1号表示为01。</div>
              <div style="margin-bottom:5px;">${d}表示日，日期不补齐，如1号表示为1。</div>
              <div style="margin-bottom:5px;">${WW}表示一年中的第几周。如小于10，则加零补齐，如1号表示为01。</div>
              <div style="margin-bottom:5px;">${W}表示一年中的第几周。不补齐，如1号表示为1。</div>
              
                <i class="el-icon-question" slot="reference"></i>
              </el-popover>
            </el-form-item>
            <el-form-item label="流水号长度：" size="small">
              <el-input-number
                v-model="dialogForm.outer.numLen"
                :min="1"
                placeholder="如：5，流水号前补0，为00001，递增。"
                clearable
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="起始箱号："
              size="small"
              prop="outerStartIndex"
            >
              <el-input-number
                v-model="dialogForm.outer.startIndex"
                :min="1"
                :precision="0"
                placeholder="默认从1开始"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="最小重量："
              size="small"
              prop="outer.minWeight"
            >
              <el-input-number
                v-model="dialogForm.outer.minWeight"
                :min="0"
                :precision="3"
                placeholder="最小重量（单位：kg）"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="最大重量："
              size="small"
              prop="outer.maxWeight"
            >
              <el-input-number
                v-model="dialogForm.outer.maxWeight"
                :min="0"
                :precision="3"
                placeholder="最大重量（单位：kg）"
              ></el-input-number>
            </el-form-item>
          </div>
          <div v-else-if="dialogTitle == `修改栈板规格`" key="pallet">
            <el-form-item
              label="栈板规格："
              size="small"
              prop="pallet.pack"
            >
              <el-input-number
                v-model="dialogForm.pallet.pack"
                :min="1"
                :precision="0"
                placeholder="每个栈板单位的裸机数量"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="混装比例："
              size="small"
              prop="palletScale"
            >
              <el-select
                v-model="dialogForm.pallet.scale"
                placeholder="选择混装比例"
                filterable
              >
                <el-option
                  v-for="(item, index) in $parent.pullDownData.cartonScaleList"
                  :key="index"
                  :label="item.title"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="栈板号模板：" size="small">
              <el-input style="width:92%;"
                v-model.trim="dialogForm.pallet.snTemplate"
                placeholder="栈板号SN模板,如AN${yyyy}${MM}${dd}"
                clearable
              ></el-input>
              <el-popover style="margin-left: 3px;"
              placement="bottom" 
              title="提示："
              trigger="hover"
              >
              <div style="margin-bottom:5px;">${yyyy}表示年，如2022年表示为2022。</div>
              <div style="margin-bottom:5px;">${yy}表示年，如2022年表示为22。</div>
              <div style="margin-bottom:5px;">${MM}表示月，如小于10月份，则加零补齐，1月表示为01。</div>
              <div style="margin-bottom:5px;">${M}表示月，月份不补齐，如1月份表示为1。</div>
              <div style="margin-bottom:5px;">${dd}表示日，如小于10号，则加零补齐，1号表示为01。</div>
              <div style="margin-bottom:5px;">${d}表示日，日期不补齐，如1号表示为1。</div>
              <div style="margin-bottom:5px;">${WW}表示一年中的第几周。如小于10，则加零补齐，如1号表示为01。</div>
              <div style="margin-bottom:5px;">${W}表示一年中的第几周。不补齐，如1号表示为1。</div>
                <i class="el-icon-question" slot="reference"></i>
              </el-popover>
            </el-form-item>
            <el-form-item label="流水号长度：" size="small">
              <el-input-number
                v-model="dialogForm.pallet.numLen"
                :min="0"
                placeholder="如：5，流水号前补0，为00001，递增。"
                clearable
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="起始栈板号："
              size="small"
              prop="palletStartIndex"
            >
              <el-input-number
                v-model="dialogForm.pallet.startIndex"
                :min="0"
                :precision="0"
                placeholder="默认从1开始"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="最小重量："
              size="small"
              prop="pallet.minWeight"
            >
              <el-input-number
                v-model="dialogForm.pallet.minWeight"
                :min="0"
                :precision="3"
                placeholder="最小重量（单位：kg）"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="最大重量："
              size="small"
              prop="pallet.maxWeight"
            >
              <el-input-number
                v-model="dialogForm.pallet.maxWeight"
                :min="0"
                :precision="3"
                placeholder="最大重量（单位：kg）"
              ></el-input-number>
            </el-form-item>
          </div>

          <template v-else-if="dialogTitle == `修改QC设置信息`">
            <el-form-item
              label="CRI AQL："
              size="small"
              prop="criAql"
            >
              <el-select v-model="dialogForm.criAql" placeholder="致命缺陷AQL值">
              <el-option
                v-for="item in this.pullDownData.aqls"
                :key="item.aqlValue"
                :label="item.aqlValue"
                :value="item.aqlValue">
              </el-option>
            </el-select>
            </el-form-item>
            <el-form-item
              label="MAJ AQL："
              size="small"
              prop="majAql"
            >
              <el-select v-model="dialogForm.majAql" placeholder="主要缺陷AQL值">
              <el-option
                v-for="item in this.pullDownData.aqls"
                :key="item.aqlValue"
                :label="item.aqlValue"
                :value="item.aqlValue">
              </el-option>
            </el-select>
            </el-form-item>
            <el-form-item
              label="MIN AQL："
              size="small"
              prop="minAql"
            >
              <el-select v-model="dialogForm.minAql" placeholder="次要缺陷AQL值">
              <el-option
                v-for="item in this.pullDownData.aqls"
                :key="item.aqlValue"
                :label="item.aqlValue"
                :value="item.aqlValue">
              </el-option>
            </el-select>
            </el-form-item>
          </template>

        </el-form>
      </template>
    </myDialog>
  </div>
</template>

<script>
import {
  apiCartonOrderDetail,
  apiCartonOrderStart,
  apiUpdateStartDateTime,
  apiUpdateCountryCode,
  apiUpdateNotes,
  apiUpdateOrderNumber,
  apiUpdateSapOrderNumber,
  apiUpdateCustomerPo,
  apiUpdateItemCode,
  apiCartonOrderSetPrimary,
  apiCartonOrderRemoveOrder,
  apiCartonOrderAddOrder,
  apiUpdateCartonSpec,  
  apiCartonOrderUpdateQuantity,
  apiCartonOrderBindPackageFid,
  apiUpdateQC
} from "@/api/cartonOrder.js";
import { apiProductionOrderList } from "@/api/productSystem.js";
import myDialog from "@/components/myDialog.vue";
import { apiUploadFile,apiDownloadFile } from "@/api/filesUpload.js";
import { apiGetAQLList } from "@/api/qcOrder.js";
export default {
  props: {
    tabPaneValue: {
      type: String,
    },
  },
  computed: {
    weightData() {
      return this.orderDetailData.weight || {};
    },
    weightData2() {
      return this.orderDetailData.weight2 || {};
    },
    innerDate() {
      return this.orderDetailData.inner || {};
    },
    outerDate() {
      return this.orderDetailData.outer || {};
    },
    palletDate() {
      return this.orderDetailData.pallet || {};
    },
    qcDate() {
      return this.orderDetailData.qc || {};
    },
  },
  components: {
    myDialog,
  },
  data() {
    return {
      orderDetailData: {},
      pullDownData: {
        productOrderList: [],
        aqls:[],
      },
      dialogTitle: "",
      dialogForm: {
        weight2: {},
        weight: {},
        inner: {},
        outer: {},
        pallet: {},
      },
      dialogRules: {
        productionOrderId: [
          { required: true, message: "组装工单不能为空！", trigger: "change" },
        ],
        dateTime: [
          { required: true, message: "开始包装时间不能为空！", trigger: "change" },
        ],
        "outer.pack": [
          { required: true, message: "包装规格不能为空！", trigger: "blur" },
          { required: true, message: "包装规格不能为空！", trigger: "change" },
        ],
        "pallet.pack": [
          { required: true, message: "栈板规格不能为空！", trigger: "blur" },
          { required: true, message: "栈板规格不能为空！", trigger: "change" },
        ],
      },
      // 包装规格名
      specName: "",
      processOrdeer: {
        proOrderFilterText: "",
        loading: false,
        // 定时器
        timer: "",
      },
      labelWidth: this.$store.state.labelWidth,
    };
  },
  methods: {
    downloadFile(fid, fileName, secretKey) {
      let a = document.createElement("a");
      if (fileName) {
        a.download = fileName;
      } else {
        a.download = "包装说明下载";
      }
      a.href = apiDownloadFile(fid, secretKey);
      a.style.display = "none";
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    // 上传包装说明按钮
    uploadPackageFidBtn() {
      this.$nextTick(() => {
        this.$refs.uploadPackageFidInput.click();
      });
    },
    // 确认上传包装说明
    async uploadPackageFidChange() {
      let files = this.$refs.uploadPackageFidInput.files;
      if (files.length) {
        let fd = new FormData();        
        fd.append("file", files[0]);
        let res = await apiUploadFile(fd);
        if (res.code == 0) {
          this.$refs.uploadPackageFidInput.value = "";
          const resBind = await apiCartonOrderBindPackageFid({
            id: this.tabPaneValue,
            fid: res.fid,
          });
          if (resBind.code == 0) {
            this.orderDetailData.packageFid = res.fid;
            this.orderDetailData.packageFidUploadDateTime = res.uploadDateTime
            this.$message({
              type: "success",
              message: `包装说明上传成功！`,
            });
          }
        }
      }
    },
    editQuantityBtn(quantity) {
      this.dialogTitle = "修改工单数量";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        quantity,
      };
    },
    // 导出
    // daochu(nodeId, downloadName) {
    //   this.$canvasDownload(nodeId, downloadName)
    // },
    // 订单详情
    async getCartonOrderDetail(callback) {
      const res = await apiCartonOrderDetail({
        id: this.tabPaneValue,
      });
      if (res.code == 0) {
        this.orderDetailData = res.data;
        // console.log(this.orderDetailData);
        this.$parent.detailData = res.data;
        if (callback) callback();
        this.getAQLList();
      }
    },
    // 修改开始包装时间
    editStartDate(dateTime) {
      this.dialogTitle = "修改开始包装时间";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        dateTime,
      };
    },
    editItemCode(itemCode) {
      this.dialogTitle = "修改成品编码";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        itemCode,
      };
    },
    editCustomerPo(customerPo) {
      this.dialogTitle = "修改客户PO/料号";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        customerPo,
      };
    },
    editOrderNumber(orderNumber) {
      this.dialogTitle = "修改包装单号";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        orderNumber,
      };
    },
    editSapOrderNumber(sapOrderNumber) {
      this.dialogTitle = "修改SAP单号";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        sapOrderNumber,
      };
    },
    editCountryCode(countryCode) {
      this.dialogTitle = "修改国家码";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        countryCode,
      };
    },
    editNotes(notes) {
      this.dialogTitle = "修改备注";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        notes,
      };
    },
    // 设置主工单
    setPrimary(e, row) {
      e.target.blur();
      this.$confirm(`是否设置${row.orderNumber}为主工单？`, "设置主工单", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiCartonOrderSetPrimary({
          id: this.tabPaneValue,
          productionOrderId: row.id,
        });
        // console.log(res)
        if (res.code == 0) {
          this.getCartonOrderDetail();
          this.$message({
            message: "设置成功",
            type: "success",
          });
        }
      });
    },
    // 删除组装工单
    deleteOrder(e, row) {
      e.target.blur();
      this.$allOperation({ name: row.orderNumber }, "删除", "组装工单").then(
        async () => {
          const res = await apiCartonOrderRemoveOrder({
            id: this.tabPaneValue,
            productionOrderId: row.id,
          });
          // console.log(res)
          if (res.code == 0) {
            this.getCartonOrderDetail();
            this.$message({
              message: "删除成功",
              type: "success",
            });
          }
        }
      );
    },
    // 添加组装工单
    addOrder() {
      this.dialogTitle = "添加组装工单";
      this.$refs.myDialog.dialogVisible = true;
    },
    // 修改内箱 && 外箱 && 栈板
    updateCartonSpec(name, type, data, data2) {
      // console.log(data);
      this.specName = name;
      this.dialogTitle = `修改${name}规格`;
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        [type] : {
          ...data,
          scale: data.scale?data.scale.code: undefined
        }
      };
      if (data2) {
        this.dialogForm.weight2=data2;
      }
      console.log(this.dialogForm);
    },
        // 修改QC设置信息
    updateQC(data) {
      this.dialogTitle = `修改QC设置信息`;
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        ...data,
      };
    },
    // 确认新建
    submitData(title, force) {
      this.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          let res = {};
          if (title == "修改工单数量") {
            res = await apiCartonOrderUpdateQuantity({
              // id: this.tabPaneValue,
              ...this.dialogForm,
              force
            });
          } else if (title == "添加组装工单") {
            res = await apiCartonOrderAddOrder({
              id: this.tabPaneValue,
              ...this.dialogForm,
            });
          } else if(title == "修改开始包装时间") {
            res = await apiUpdateStartDateTime({
              ...this.dialogForm,
            });
          } else if(title =="修改成品编码") {
            res = await apiUpdateItemCode({
              ...this.dialogForm,
            });
          } else if (title == "修改客户PO/料号") {
            res = await apiUpdateCustomerPo({
              ...this.dialogForm,
            });
          } else if(title == "修改包装单号") {
            res = await apiUpdateOrderNumber({
              ...this.dialogForm,
            });
          } else if(title == "修改SAP单号") {
            res = await apiUpdateSapOrderNumber({
              ...this.dialogForm,
            });
          } else if(title == "修改国家码") {
            res = await apiUpdateCountryCode({
              ...this.dialogForm,
            });
          } else if(title == "修改备注") {
            res = await apiUpdateNotes({
              ...this.dialogForm,
            });
          } else if(title == `修改${this.specName}规格`) {
            res = await apiUpdateCartonSpec({
              ...this.dialogForm,
            })
          }
          else if(title == `修改QC设置信息`) {
            res = await apiUpdateQC({
              ...this.dialogForm,
            })
          }
          if (res.code == 0) {
            this.$refs.myDialog.dialogVisible = false;
            this.getCartonOrderDetail();
            this.$message({
              message: `${title.substr(0,2)}成功`,
              type: "success",
            });
          } else if (res.code == 1024) {
            this.$confirm(res.msg, "强制执行", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }).then(() => {
              this.submitData(title, true);
            });
          }
        } else {
          return false;
        }
      });
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.dialogForm.resetFields();
      this.dialogForm = {
        weight: {},
        weight2: {},
        inner: {},
        outer: {},
        pallet: {},
      };
      this.pullDownData.productOrderList = [];
    },
    // 组装工单数据请求
    remoteMethod(e) {      
      let query = e.target.value;
      let processOrdeer = this.processOrdeer;
      clearTimeout(processOrdeer.timer);
      processOrdeer.proOrderFilterText = query;
      if (query.length >= 5) {
        if (processOrdeer.loading) return;
        processOrdeer.loading = true;
        processOrdeer.timer = setTimeout(async () => {
          const res = await apiProductionOrderList({
            orderNumber: query,
            status: ["PRODUCTION"],
          });
          if (res.code == 0) {
            processOrdeer.loading = false;
            this.pullDownData.productOrderList = res.data;
          }
        }, 1000);
      } else {
        processOrdeer.loading = false;
        this.pullDownData.productOrderList = [];
      }
    },
    async getAQLList() {
      const res = await apiGetAQLList({
        
      });
      if (res.code == 0) {
        this.pullDownData.aqls = res.data;
        this.pullDownData.aqls.unshift({aqlValue: 0});
      }
    },
    // 开始生产
    startOrder(row, msg = `现在开始生产：${row.orderNumber} ？`, force) {
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiCartonOrderStart({
          id: row.id,
          force,
        });
        if (res.code == 0) {
          this.getCartonOrderDetail();
          this.$message({
            type: "success",
            message: "开始成功",
          });
        } else if (res.code == 1024) {
          setTimeout(() => {
            this.startOrder(row, res.msg, true);
          }, 300);
        }
      });
    }
  },
};
</script>

<style lang="less" scoped>
.myProductionOrder {
  /deep/.el-table__body-wrapper {
    tbody {
      .el-table__row:last-child {
        font-weight: 700;
      }
    }
  }
}
.titleBox {
  margin-top: 20px;
}
</style>